import { useField } from 'formik'
import { useTranslation } from 'react-i18next'

import { InputLabel, TextareaContainer } from './styled'

type TextInputProps = {
  name: string
  placeholder: string
  disabled?: boolean
  label?: string
  borderLight?: boolean
  [key: string]: unknown
}

export function Textarea({
  name,
  placeholder,
  disabled,
  label,
  borderLight,
  ...rest
}: TextInputProps): JSX.Element {
  const { t } = useTranslation(['validation'])

  const [field, meta] = useField({ name })

  return (
    <>
      {!!label && <InputLabel>{label}</InputLabel>}
      <TextareaContainer
        hasError={meta.touched && !!meta.error}
        borderLight={borderLight}
      >
        <textarea
          id={name}
          placeholder={placeholder}
          disabled={disabled}
          {...field}
          {...rest}
          tabIndex={disabled ? -1 : 0}
        />
        {meta.touched && !!meta.error && (
          <p>
            {t(`validation:${meta.error}`, {
              field: placeholder
            })}
          </p>
        )}
      </TextareaContainer>
    </>
  )
}
